import React from 'react';

interface MoneyIconProps {
  fill: string;
  width?: number;
  height?: number;
}

const MoneyIcon = ({
                     fill = 'black',
                     width = 28,
                     height = 25
                   }: MoneyIconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 28 25'
    >
      <path
        id='icon-coin'
        d='M11.73,21.292v-.8a1.824,1.824,0,0,1,.171-.76c.769,1.684,4.043,2.948,7.964,2.948s7.2-1.265,7.964-2.948a1.821,1.821,0,0,1,.171.76v.8C28,23.34,24.358,25,19.865,25S11.73,23.34,11.73,21.292ZM0,19.069v-.8a1.824,1.824,0,0,1,.171-.76c.769,1.684,4.042,2.948,7.964,2.948a17.292,17.292,0,0,0,2.267-.147v.985a2.945,2.945,0,0,0,.3,1.3,17.214,17.214,0,0,1-2.57.189C3.642,22.777,0,21.118,0,19.069Zm11.73-1.916v-.8a1.818,1.818,0,0,1,.171-.76c.769,1.683,4.043,2.948,7.964,2.948s7.2-1.265,7.964-2.948a1.818,1.818,0,0,1,.171.76v.8c0,2.047-3.642,3.708-8.135,3.708S11.73,19.2,11.73,17.153ZM0,14.93v-.8a1.824,1.824,0,0,1,.171-.76c.769,1.684,4.043,2.948,7.964,2.948a17.449,17.449,0,0,0,2.267-.147v2.324a17.463,17.463,0,0,1-2.267.146C3.642,18.638,0,16.978,0,14.93Zm11.73-2.14v-.8a1.824,1.824,0,0,1,.171-.76c.769,1.684,4.043,2.948,7.964,2.948s7.2-1.264,7.964-2.948a1.824,1.824,0,0,1,.171.76v.8c0,2.048-3.642,3.708-8.135,3.708S11.73,14.838,11.73,12.79ZM0,10.791v-.8C0,7.939,3.642,6.279,8.135,6.279a17.452,17.452,0,0,1,2.267.146v7.927a17.3,17.3,0,0,1-2.267.147C3.642,14.5,0,12.839,0,10.791Zm11.73-2.14v-.8a1.821,1.821,0,0,1,.171-.76c.769,1.684,4.043,2.948,7.964,2.948s7.2-1.264,7.964-2.948a1.821,1.821,0,0,1,.171.76v.8c0,2.048-3.642,3.708-8.135,3.708S11.73,10.7,11.73,8.651Zm0-4.139v-.8C11.73,1.66,15.372,0,19.865,0S28,1.66,28,3.708v.8c0,2.048-3.642,3.708-8.135,3.708S11.73,6.559,11.73,4.512Z'
        fill={fill}
      />
    </svg>
  );
};

export default MoneyIcon;
